import { all, takeLatest } from 'redux-saga/effects';
import {
  CREATE_GROUP,
  GET_GROUPS,
  GET_GROUP_DETAILS,
  CONFIRM_GROUP,
  SET_ADD_EMPLOYEE_TOPUP_CYCLE,
} from '../../actions/groups';
import {
  createGroupSaga,
  getAllGroupsSaga,
  getGroupDetailsSaga,
  confirmGroupSaga,
  setAddEmployeeTopupCycleSaga,
} from './getGroupsSaga';

function* groupSagas() {
  yield all([
    yield takeLatest(GET_GROUPS.INITIATE, getAllGroupsSaga),
    yield takeLatest(GET_GROUP_DETAILS.INITIATE, getGroupDetailsSaga),
    yield takeLatest(CREATE_GROUP.INITIATE, createGroupSaga),
    yield takeLatest(CONFIRM_GROUP.INITIATE, confirmGroupSaga),
    yield takeLatest(
      SET_ADD_EMPLOYEE_TOPUP_CYCLE.INITIATE,
      setAddEmployeeTopupCycleSaga,
    ),
  ]);
}

export default groupSagas;
